<app-navbar></app-navbar>

<iframe #pdfViewer class="full-width"></iframe>